<template>
    <div id="import-status-card" :class="{ 'minimized': minimized }">
        <div v-if="!minimized" class="content">
            <BucketSpinner class-name="spinner" />
            <div class="items">
                <div class="item">
                    <i class="material-icons text-success">check_circle</i>
                    {{ state.imported }} {{ $t("auto.completed") }}
                </div>
                <div class="item">
                    <i class="material-icons text-danger">cancel</i>
                    {{ state.failed }} {{ $t("auto.failed") }}
                </div>
                <div class="item">
                    <i class="material-icons text-info" :class="{ 'spin': state.status === 'processing' }">loop</i>
                    {{ state.percent }}% {{ $t("auto.completed") }}
                </div>
            </div>
            <div class="close-btn" @click="minimize">
                <i class="material-icons">close</i>
            </div>
        </div>
        <div v-else class="minimized-content" @click="maximize">
            <i class="material-icons spin">autorenew</i>
            <div class="minimized-text">{{ state.percent }}%</div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import BucketSpinner from "../../../Reports/common/spinners/BucketSpinner.vue";

export default Vue.extend({
    name: "ImportStatusViewer",
    components: { BucketSpinner },
    props: {
        state: {
            type: Object,
            default: () => {
                return {
                    status: "processing",
                    imported: 0,
                    failed: 0,
                    total: 0,
                    percent: 0,
                };
            },
        },
    },
    data() {
        return {
            minimized: false
        };
    },
    methods: {
        minimize() {
            this.minimized = true;
        },
        maximize() {
            this.minimized = false;
        }
    },
    watch: {
        'state.status': {
            handler(newStatus) {
                if (newStatus === 'completed') {
                    setTimeout(() => {
                        this.$emit('close');
                    }, 3000);
                }
            },
            immediate: true
        }
    }
});
</script>

<style scoped lang="scss">
#import-status-card {
    position: fixed;
    bottom: 20px;
    right: 20px;
    padding: 20px;
    color: #fff;
    background-color: #333;
    min-width: 300px;
    z-index: 9999999;
    border-radius: 8px;
    display: flex;
    align-items: center;
    align-content: center;
    gap: 5px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;

    .content {
        display: flex;
        align-items: center;
        gap: 8px;
        width: 100%;
        height: 100%;
    }

    &.minimized {
        min-width: auto;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        padding: 0;
        bottom: 25px;
        right: 25px;
        cursor: pointer;

        .minimized-content {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;

            .material-icons {
                font-size: 20px;
                margin-bottom: 2px;
            }

            .minimized-text {
                font-size: 12px;
                font-weight: bold;
            }
        }
    }

    .close-btn {
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
        opacity: 0.7;
        transition: opacity 0.2s;

        &:hover {
            opacity: 1;
        }

        .material-icons {
            font-size: 18px;
        }
    }

    svg.spinner {
        background-color: #333 !important;
        width: 40px !important;
        height: 40px !important;
        margin: 0 !important;
    }

    .items {
        display: flex;
        flex-direction: column;
        gap: 8px;

        .item {
            display: flex;
            gap: 8px;
            align-items: center;

            .material-icons {
                font-size: 16px;
            }
        }
    }

    .text-success {
        color: #52c41a;
    }

    .text-danger {
        color: #f5222d;
    }

    .text-info {
        color: #1890ff;
    }

    .spin {
        animation: spin 1.5s linear infinite;
    }

    @keyframes spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
}
</style>
